import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import Snackbar from 'material-ui/Snackbar';
import Paper from 'material-ui/Paper';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Avatar from 'material-ui/Avatar';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import {greenA700} from 'material-ui/styles/colors'
import FlatButton from 'material-ui/FlatButton';

import ContactList from './ContactList';
import ContactWindow from './ContactWindow';
import LoginDialog from './LoginDialog';
import AccountMenu from './AccountMenu';
import IncomingCall from './IncomingCall';
import ConfirmContactDeleteDialog from './ConfirmContactDeleteDialog'
import ContactEditor from './ContactEditor';
import SupporterProfile from './SupporterProfile';
import Help from './Help';

import { intlShape } from 'react-intl';

import {grey100} from 'material-ui/styles/colors'

import defaultTheme from './defaultTheme'
import LanguageSwitcher from './LanguageSwitcher'
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem/MenuItem';

const localeMessages = {
  anonymous: {
    id: "Supporter.App.Anonymous",
    defaultMessage: "Anonym"
  },
  mailsent: {
    id: 'Supporter.App.MailSent',
    defaultMessage: 'E-Mail versendet'
  },
  mailsendfailed: {
    id: 'Supporter.App.MailSendFailed',
    defaultMessage: 'E-Mail-Versand fehlgeschlagen'
  },
  contactdeleted: {
    id: 'Supporter.App.ContactDeleted',
    defaultMessage: 'Kontakt {name} gelöscht'
  },
  contactdeletefailed: {
    id: 'Supporter.App.ContactDeleteFailed',
    defaultMessage: 'Kontakt {name} konnte nicht gelöscht werden'
  },
  contactsavefailed: {
    id: 'Supporter.App.ContactSaveFailed',
    defaultMessage: 'Änderungen an Kontakt {name} konnten nicht gespeichert werden'
  },
  contactchanged: {
    id: 'Supporter.App.ContactChanged',
    defaultMessage: 'Kontakt {name} geändert'
  },
  contactadded: {
    id: 'Supporter.App.ContactAdded',
    defaultMessage: 'Kontakt {name} hinzugefügt'
  },
  incomingCall: {
    id: 'Client.ClientIncomingCall.CallerMsg',
    defaultMessage: '{name} ruft an'
  },
  noWebcam: {
    id: "Shared.App.NoWebcam",
    defaultMessage: "Es wurde keine Webcam erkannt"
  },
  webcamBusy: {
    id: "Shared.App.WebcamBusy",
    defaultMessage: "Webcam ist belegt. Versuchen Sie es bitte erneut."
  },
  webcamDenied: {
    id: "Shared.App.WebcamDenied",
    defaultMessage: 'Sie müssen Zugriff auf die Webcam erlauben.'
  },
  webcamUnknownError: {
    id: "Shared.App.WebcamUnknownError",
    defaultMessage: 'Unbekannter Webcamfehler: {error}'
  },
  newContact: {
    id: "Supporter.App.NewContact",
    defaultMessage: 'Neuer Kontakt'
  },
  endCallForHelp: {
    id: "Supporter.App.EndCallForHelp",
    defaultMessage: "Bitte beenden Sie das Gespräch zur Anzeige der Hilfestellungen."
  },
  endCallForLink: {
    id: "Supporter.App.EndCallForLink",
    defaultMessage: "Bitte beenden Sie das Gespräch zur Anzeige Ihrer Links."
  },
  showLinks: {
    id: 'Supporter.App.ShowLinks',
    defaultMessage: 'Meine Links anzeigen'
  },
  helpSupport: {
    id: 'Supporter.Help.Help',
    defaultMessage: 'Hilfe & Support'
  },
  connectedContacts: {
    id: 'Supporter.ContactList.OnlineContacts',
    defaultMessage: 'Verbundene Kontakte'
  },
  passedConversations: {
    id: 'Supporter.ContactList.PastConversations',
    defaultMessage: "Vergangene Konversationen"
  }
};

const iceServers = [
  { urls: "stun:ms-comm.ca7cthywqan.nooon.io:443" },
  { urls: "turns:ms-comm.ca7cthywqan.nooon.io:443?transport=udp", 'username': 'nooon', 'credential': '7eQioJtCw9if' },
  { urls: "turns:ms-comm.ca7cthywqan.nooon.io:443?transport=tcp", 'username': 'nooon', 'credential': '7eQioJtCw9if' }
];

class App extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  constructor(props) {
    super(props);
    
    this.socket = this.props.socket;
    this.callStatusTimeout = null;

    this.socket.on('connect', () => {
      this.setState(this.getInitialState(), () => {
        this.socket.emit('identify', {
          userAgent: window.navigator.userAgent,
        });
        this.readDevices();
      });
    });

    this.socket.on('disconnect', () => {
      if (this.state.calling) {
        this.stopCall();
        this.clearCall();
        this.setState({
          callStatus: null
        });
      }
      this.setState(this.getInitialState());
    });

    this.socket.on('authenticated', (user) => {
      this.authenticated(user)
    });
    this.socket.on('authfail', (user) => {
      this.setState({authfail: true, user: null});
    });
    this.socket.on('logout', (user) => {
      this.loggedout();
    });
    this.socket.on('helprequest', (data) => {
      console.log("Somebody has problems", data);
    });

    this.socket.on('queue', (newQueue) => {
      let queue = this.state.queue;
      let staleQueue = this.state.staleQueue;

      // remove disconnected clients
      queue = queue.filter(s => {
        const inNewQueue = newQueue.find(sNew => s.id === sNew.id);

        if (!inNewQueue) {
          s.online = false;
          staleQueue.unshift(s);

          this.addEvent(s, s, 'offline');

          if (this.state.calling && this.state.calling.id === s.id) {
            this.stopCall();
            this.clearCall();
            this.setState({
              callStatus: null
            });
          }

          // remove incoming call from this user if any
          this.removeIncomingCall(s);
            
          return false;
        }
        else {
          return true;
        }
      });

      // merge/add new clients
      newQueue.forEach(sNew => {
        const inQueue = queue.find(s => s.id === sNew.id);

        if (inQueue) {
          Object.assign(inQueue, sNew);
          this.establishDataChannel(inQueue);
        }
        else {
          sNew.online = true;
          sNew.name = "name" in sNew && sNew.name ? sNew.name : this.context.intl.formatMessage(localeMessages.anonymous);
          queue.push(sNew);

          this.addEvent(sNew, sNew, 'online');

          this.establishDataChannel(sNew);
        }
      });

      this.setState({
        queue: queue,
        staleQueue: staleQueue
      });
    });

    this.socket.on('pc', (msg) => this.processPcMsg(msg));
    this.socket.on('mailsent', () => this.showInfo(this.context.intl.formatMessage(localeMessages.mailsent)));
    this.socket.on('mailsendfailed', () => this.showInfo(this.context.intl.formatMessage(localeMessages.mailsendfailed)));
    this.socket.on('contactdeleted', (c) => this.showInfo(this.context.intl.formatMessage(localeMessages.contactdeleted, {name: c.name})));
    this.socket.on('deletecontactfailed', (c) => this.showInfo(this.context.intl.formatMessage(localeMessages.contactdeletefailed, {name: c.name})));
    this.socket.on('modifycontactfailed', (c) => this.showInfo(this.context.intl.formatMessage(localeMessages.contactsavefailed, {name: c.name})));
    this.socket.on('contactmodified', (c) => this.showInfo(this.context.intl.formatMessage(localeMessages.contactchanged, {name: c.name})));
    this.socket.on('contactcreated', (c) => this.showInfo(this.context.intl.formatMessage(localeMessages.contactadded, {name: c.name})));

    const callSound = new Audio('incoming.mp3');
    callSound.loop = true;
    callSound.load();
    this.callSound = callSound;

    if (window.Notification && Notification.permission !== "granted") {
      Notification.requestPermission(function (status) {
        if (Notification.permission !== status) {
          Notification.permission = status;
        }
      });
    }

    navigator.mediaDevices.ondevicechange = () => this.readDevices;

    this.state = this.getInitialState();
    this.updateStreamStats();
  }

  slog(msg) {
    setTimeout(() => {
      this.socket.emit('syslog', msg);
    }, 16);

    var args = Array.prototype.slice.call(arguments);
    args.unshift('Syslog:');
    console.log.apply(console, args);
  }

  elog(msg) {
    var args = Array.prototype.slice.call(arguments);
    setTimeout(() => {
      this.socket.emit('errorlog', JSON.stringify(args));
    }, 16);

    args.unshift('Errorlog:');
    console.log.apply(console, args);
  }

  ulog(msg) {
    setTimeout(() => {
      this.socket.emit('actionlog', msg);
    }, 16);

    var args = Array.prototype.slice.call(arguments);
    args.unshift('Actionlog:');
    console.log.apply(console, args);
  }

  getInitialState() {
    return {
      user: null,
      contacts: {},
      queue: [],
      staleQueue: [], 
      calling: false,
      authfail: false,
      loggedout: false,
      roomnames: this.props.roomnames || ['nextcare'],
      labels: this.props.labels || {
        title: 'Nextcare',
        patients: 'Patienten',
        professionals: 'Professionals'
      },
      mailfooter: this.props.mailfooter || 'Default mail footer',
      mailsender: this.props.mailsender || 'default@example.org',
      activeConversation: null,
      showInfo: false,
      contactOpen: null,
      incomingCallQueue: {},
      callSoundCanPlay: false,
      clientprefix: this.props.clientprefix || 'go.ms-preview',
      theme: this.props.theme || getMuiTheme(defaultTheme),
      videoDevices: [],
      audioDevices: [],
      muteRemote: false,
      muteLocal: false,
      disableCam: false,
      activeCamDevice: 0,
      callStatus: null,
      recoverCountRemote: 0,
      recoverCountLocal: 0
    };
  }

  updateStreamStats() {
    if (this.state.calling && this.state.calling.pc) {
      this.state.calling.pc.getStats(null)
      .then((r) => {
        r.forEach((v, k) => {
          // console.log('remote', v.type);
        });
      });
    }

    setTimeout(() => this.updateStreamStats(), 1000);
  }

  readDevices() {
    let video = [];
    let audio = [];
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        devices.forEach(d => {
          if (d.kind === 'videoinput') {
            video.push(d);
          }
          else if (d.kind === 'audioinput') {
            audio.push(d);
          }
        });
        
        this.setState({videoDevices: video, audioDevices: audio});

        this.slog(`Videodevices: ${video.length}, Audiodevices: ${audio.length}`);
      });
  }

  clearCallStatus() {
    this.setState({
      callStatus: null
    });
  }

  showContact(contact) {
    this.setState({
      contactOpen: contact,
      showHelp: false
    });
  }

  componentDidUpdate(pP, pS) {
    if (this.state.callStatus != pS.callStatus) {
      this.slog(`Callstatus: ${this.state.callStatus}`);
    }
    
    if (this.callStatusTimeout !== null) {
      clearTimeout(this.callStatusTimeout);
    }

    if (['stopped', 'denied'].indexOf(this.state.callStatus) !== -1) {
      this.state.callStatusTimeout = setTimeout(() => {
        this.clearCallStatus();
      }, 3000);
    }
  }

  componentWillUpdate(nP, nS) {
    const hasIncomingCall = Object.keys(nS.incomingCallQueue).length;
    const hadIncomingCall = Object.keys(this.state.incomingCallQueue).length;

    try {
      if (hasIncomingCall) {
        if (!hadIncomingCall && this.callSound.paused) {
          this.callSound.currentTime = 0;
        }

        if (this.callSound.paused) {
          const playPromise = this.callSound.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.log("ERROR", error);
            });
          }
        }
      }
      else {
        this.callSound.pause();
      }
    } catch (e) {
      console.log(e);
    }
  }

  addIncomingCall(contact) {
    if (this.state.calling && contact.id === this.state.calling.id) {
      return;
    }

    if (window.Notification && Notification.permission === "granted") {
      const n = new Notification("MediService Nextcare", {
        body: this.context.intl.formatMessage(localeMessages.incomingCall, {name: contact.name}),
        lang: this.props.locale,
        icon: 'Logo_' + this.props.locale + '.svg',
        badge: 'Logo_' + this.props.locale + '.svg'
      });

      n.addEventListener('click', () => window.focus());
      contact.notification = n;
    }

    this.state.incomingCallQueue[contact.id] = contact;

    this.setState({
      incomingCallQueue: this.state.incomingCallQueue
    });
  }

  removeIncomingCall(contact) {
    contact = this.state.incomingCallQueue[contact.id];

    if (!contact) {
      return false;
    }

    if (contact.notification) {
      contact.notification.close();
    }

    delete this.state.incomingCallQueue[contact.id];

    this.setState({
      incomingCallQueue: this.state.incomingCallQueue
    });
  }

  acceptCall(contact) {
    this.sendMessage(contact, {action: 'accepted'}, 'call');
    this.addEvent(contact, this.state.user, 'accepted');
    this.removeIncomingCall(contact);

    this.stopCall(() => {
      this.call(contact);
    });
  }

  denyCall(contact) {
    this.sendMessage(contact, {action: 'denied'}, 'call');
    this.addEvent(contact, this.state.user, 'denied');
    this.removeIncomingCall(contact);
  }

  call(contact) {
    console.log("Calling", contact.id);
    this.setState({calling: contact, contactOpen: contact}, () => {
      if (!contact.pc) {
        this.establishPeerconnection(contact);
      }

      this.sendMessage(contact, {action: 'callstart'}, 'call');

      window.pc = contact.pc;
      setTimeout(() => {
        this.setupLocalStream({});
      });
    });
  }

  setupLocalStream(video, _camDevice) {
    /*
    if (!this.state.videoDevices.length) {
      alert("Es scheint als hätten Sie keine Webcam installiert.");
      return;
    }
    */

    let devices = this.state.videoDevices;
    let camDevice = _camDevice != null ? _camDevice : this.state.activeCamDevice;

    if (camDevice === null || camDevice >= devices.length) {
      camDevice = 0;
    }

    video = {}; /*!video ? {
      deviceId: {exact: devices[camDevice].deviceId}
    } : video;*/

    navigator.mediaDevices.getUserMedia({
      audio: true,
      video: video
    })
    .then((stream) => {
      console.log("Got local stream");

      this.slog(`Access to webcam granted`);

      const currentStream = this.state.user.stream;

      this.state.user.stream = stream;

      if (this.state.calling && this.state.calling.pc) {
        console.log("Adding local tracks");
        stream.getTracks().forEach(track => this.state.calling.pc.addTrack(track, stream));
        console.log("Added tracks to pc");

        if (this.state.calling.negotiationneeded) {
          this.sendOffer(this.state.calling);
        }
        else {
          console.log("Got local tracks, waiting for client");
        }
      }
      else {
        console.log("not sending offer, no caller");
      }

      this.setState({
        user: this.state.user,
        queue: this.state.queue,
        activeCamDevice: camDevice
      }, () => {
        if (currentStream) {
          console.log("Stopping local tracks");
          currentStream.getTracks().forEach((s) => {
            currentStream.removeTrack(s);
            s.stop();
          });

          if (this.state.calling.pc) {
            this.state.calling.pc.removeStream(currentStream);
          }
        }
      });
    })
    .catch((e) => {
      console.log(e);
      this.elog(`Setup local stream ${e.name}`);

      if ("constraint" in e && e.constraint) {
        this.readDevices();
        var devices = this.state.videoDevices;

        this.setupLocalStream(null, camDevice++);
      }
      else {
        switch (e.name) {
          case 'NotFoundError':
          case 'DevicesNotFoundError':
            alert(this.context.intl.formatMessage(localeMessages.noWebcam));
            break;
          case 'AbortError':
          case 'NotReadableError':
          case 'SourceUnavailableError':
            alert(this.context.intl.formatMessage(localeMessages.webcamBusy));
            break;
          case 'PermissionDeniedError':
          case 'SecurityError':
          case 'NotAllowedError':
            alert(this.context.intl.formatMessage(localeMessages.webcamDenied));
            break;
          default:
            alert(this.context.intl.formatMessage(localeMessages.webcamUnknownError, {error: e.name}));
            break;
        }

        this.stopCall();
      }
    });
  }

  establishDataChannel(contact) {
    console.log("Establishing Datachannel RTC with", contact.id);

    if (contact.datapc && contact.datapc.iceConnectionState !== 'failed' && contact.datapc.iceConnectionState !== 'closed') {
      console.log("Datachannel exists,   skipping", contact.pc);
      return;
    }

    const pc = new RTCPeerConnection({
      iceServers: iceServers
    });

    contact.datapc = pc;

    let evtl = (evt) => {
      console.log("Datachannel RTC", evt.type, JSON.parse(JSON.stringify(evt)));
      this.setState({queue: this.state.queue});
    };
    pc.onconnectionstatechange = evtl;
    pc.oniceconnectionstatechange = evtl;
    pc.onicegatheringstatechange = evtl;
    pc.onidentityresult = evtl;
    pc.onpeeridentity = evtl;
    pc.onsignalingstatechange = (e) => {
      console.log("Signaling state", pc.signalingState);
      if (pc.signalingState === 'closed') {
        delete contact.datapc;
      }
    };

    setTimeout(() => {
      this.sendOffer(contact, true);
    }, 16);

    pc.onnegotiationneeded = (evt) => {
      console.log("Datachannel Negotiationneeded", contact.id, "skipping");
    };

    pc.onicecandidate = (evt) => {
      if (evt.candidate) {
        console.log("Received local ice candidate", evt.candidate);
        this.socket.emit('pc', {
          'for': contact.id,
          'candidate': evt.candidate,
          'datachannel': true
        });
      }
    };

    // create a data channel
    if ("createDataChannel" in pc) {
      let dataChannel = pc.createDataChannel("conn", {
        ordered: true
      });

      dataChannel.onerror = function (error) {
        contact.state = 'error';
        this.setState({queue: this.state.queue});
      };

      dataChannel.onmessage = (event) => {
        console.log("Remote DC message", event);
        var data = JSON.parse(atob(event.data));
        this.processDcMessage(data, contact);
      };

      dataChannel.onopen = function () {
        console.log("Datachannel to", contact, "opened");
      };

      dataChannel.onclose = function () {
        console.log("The Data Channel is Closed");
      };

      contact.datachannel = dataChannel;
    }

    contact.messages = [];
    contact.metadataInquiries = [];
    contact.metadata = {};
    contact.events = (contact.events ? contact.events : []);
  }

  establishPeerconnection(contact) {
    console.log("Establishing RTC with", contact.id);

    if (contact.pc && contact.pc.iceConnectionState !== 'failed' && contact.pc.iceConnectionState !== 'closed') {
      return;
    }

    const pc = new RTCPeerConnection({
      iceServers: iceServers
    });

    contact.pc = pc;

    let evtl = (evt) => {
      console.log(evt.type, JSON.parse(JSON.stringify(evt)));
      this.setState({queue: this.state.queue});
    };
    contact.pc.onconnectionstatechange = evtl;
    contact.pc.oniceconnectionstatechange = evtl;
    contact.pc.onicegatheringstatechange = evtl;
    contact.pc.onidentityresult = evtl;
    contact.pc.onpeeridentity = evtl;
    contact.pc.onsignalingstatechange = (e) => {
      console.log("Signaling state", pc.signalingState);
      if (pc.signalingState === 'closed') {
        delete contact.pc;
      }
    };

    contact.pc.onnegotiationneeded = (evt) => {
      console.log("Negotiationneeded", contact.id);
    };
    
    pc.onicecandidate = (evt) => {
      if (evt.candidate) {
        console.log("Received local ice candidate", evt.candidate);
        this.socket.emit('pc', {
          'for': contact.id,
          'candidate': evt.candidate
        });
      }
    };

    // once remote track arrives, show it in the remote video element
    pc.ontrack = (evt) => {
      contact.stream = evt.streams[0];
      console.log("Got remote stream", evt.streams);
      const queue = this.state.queue.slice();
      this.setState({
        queue: queue,
        contactOpen: this.state.contactOpen,
        calling: this.state.calling
      });
    };
  }

  sendOffer(contact, datachannel) {
    let pc = datachannel ? contact.datapc : contact.pc;

    if (!datachannel) {
      contact.negotiationneeded = false;
    }

    if (pc) {
      pc.createOffer().then((desc) => {
        console.log("Offer created, setting local description", desc);
        pc.setLocalDescription(desc)
        .then(() => {
          console.log("Local description set");
          this.socket.emit('pc', {
            'for': contact.id,
            'desc': desc,
            'datachannel': datachannel
          });
        })
        .catch((e) => console.log(e));
      },
        function(e) { console.log("Offer creation failed", e); },
      );
    }
    else {
      console.log("Tried to send offer on non-existing pc", contact, datachannel);
    }
  }

  processDcMessage(data, contact) {
    if (data.type == 'chat') {
      const messages = contact.messages.slice();
      data.time = new Date(); // send time to arrival time
      messages.push(data);
      contact.messages = messages;
      this.setState({queue: this.state.queue});
      this.slog(`Chat message received from ${contact.id}`);
    }
    else if (data.type == 'call') {
      switch (data.action) {
        case 'init':
          this.addEvent(contact, contact, 'calling');
          this.addIncomingCall(contact);
          break;
        case 'negotiate':
          console.log("Remote negotiation requested");
          this.addEvent(contact, contact, 'change');
          contact.negotiationneeded = true;
          
          this.setState({
            calling: this.state.calling
          });

          if (this.state.user.stream) {
            this.sendOffer(contact);
          }
          else {
            console.log("Local stream not ready yet, not sending offer");
          }
          break;
        case 'stop':
          if (this.state.calling && this.state.calling.id === contact.id) {
            if (!data.hide) {
              this.addEvent(contact, contact, 'callend');
              this.stopCall(() => {}, data.hide);
              this.setState({
                callStatus: 'stopped'
              });
            }
          }

          break;
        case 'recover':
          if (this.state.recoverCountRemote > 1) {
            console.log("Reconnect");
            this.reconnect();
          }
          else {
            this.addEvent(contact, contact, 'recover');
            this.switchCam();
            this.setState({
              callStatus: 'recovering',
              recoverCountRemote: this.state.recoverCountRemote + 1
            });
          }
          break;
        case 'streamsrunning':
          this.setState({
            recoverCountRemote: 0
          });
          break;
        case 'reconnect':
          this.reconnect();
          break;
        case 'accepted':
          this.addEvent(contact, contact, 'accepted');
          this.call(contact);
          this.setState({
            callStatus: 'accepted'
          });
          break;
        case 'denied':
          this.addEvent(contact, contact, 'denied');
          this.setState({
            callStatus: 'denied'
          });
          break;
        case 'abort':
          this.addEvent(contact, contact, 'abort');
          this.removeIncomingCall(contact);
          break;
      }
    }
  }

  reconnect() {
    let contact = this.state.calling;
    this.stopCall(() => {
      if (contact) {
        this.call(contact);
      }
    }, true);
  }

  addEvent(contact, issuer, type) {
    if (!contact.events) contact.events = [];
    const event = {
      type: type,
      from: issuer,
      time: new Date()
    };

    setTimeout(() => {
      const events = contact.events.slice();

      events.push(event);

      contact.events = events;

      this.setState({
        contactOpen: this.state.contactOpen
      });
    }, 500);
  }

  processPcMsg(message) {
    const contact = this.state.queue.find(s => s.id === message.from);
    let pc = null;

    if (!contact) {
      console.log("No contact found for", message.from, this.state.queue);
      return;
    }

    console.log("Incoming PC", message, "Data channel is", contact.datachannel ? contact.datachannel.readyState : 'not existing');

    if (message.desc || message.candidate) {
      if (message.datachannel) {
        if (!contact.datapc) {
          this.establishDataChannel(contact);
        }

        pc = contact.datapc;
      }
      else {
        if (!contact.pc) {
          this.establishPeerconnection(contact);
        }

        pc = contact.pc;
      }
    }

    setTimeout(() => {
      if (message.desc) {
        const desc = message.desc;

        console.log("Setting remote description", desc);
        pc.setRemoteDescription(desc)
          .then((e) => {
            console.log("Remote description set", desc);
          })
          .catch((e) => console.log(e));
      }
      else if (message.candidate) {
        pc.addIceCandidate(message.candidate).catch((e) => console.log(e));
      }
      else {
        this.processDcMessage(message, contact);
      }
    }, 16);
  }
  
  authenticated(user) {
    this.setState({
      user: user
    });
  }

  logout() {
    this.socket.emit('logout');
    window.location.reload();
  }

  loggedout() {
    if (this.state.user && this.state.user.stream) {
      this.state.user.stream.getTracks().forEach((s) => s.stop());
    }

    this.setState(Object.assign({}, this.getInitialState(), {
      loggedout: true,
      user: null
    }));

    this.callSound.pause();
  }

  sendMail = (data) => {
    this.socket.emit('mail', data);
  }

  showInfo = (msg) => {
    this.setState({
      showInfo: msg
    });
  }

  hideInfo = () => {
    this.setState({
      showInfo: false
    });
  }

  requestAuthentication(username, password) {
    this.setState({
      loggedout: false,
      authfail: false
    }, () => {
      this.socket.emit('authenticate', {username: username.toLowerCase(), password: password});
      localStorage.setItem('username', username);
    });
  }

  showContactEditor(contact) {
    this.setState({
      editContact: contact
    });
  }

  showConfirmContactDelete(contact) {
    this.setState({
      confirmContactDeletion: contact
    });
  }

  deleteContact(contact) {
    this.socket.emit('deletecontact', contact);
  }

  saveContact(contact) {
    this.socket.emit('savecontact', contact);
  }

  newContact(attributes) {
    const contact = Object.assign({
      name: this.context.intl.formatMessage(localeMessages.newContact)
    }, attributes)

    this.setState({
      editContact: contact
    });
  }

  stopStreams() {    
    if (this.state.calling && this.state.calling.stream) {
      this.state.calling.stream.getTracks().forEach((s) => {
        this.state.calling.stream.removeTrack(s);
        s.stop()
      });

      if (this.state.calling.pc) {
        this.state.calling.pc.removeStream(this.state.calling.stream);
      }
    }

    if (this.state.user.stream) {
      this.state.user.stream.getTracks().forEach((s) => {
        this.state.user.stream.removeTrack(s);
        s.stop()
      });

      if (this.state.calling && this.state.calling.pc) {
        this.state.calling.pc.removeStream(this.state.user.stream);
      }
    }
  }

  clearCall() {
    this.setState({
      calling: null,
      muteRemote: false,
      muteLocal: false,
      disableCam: false,
      callStatus: null
    });
  }

  stopCall(cb, hideStop) {
    this.setState({
      recoverCountLocal: 0,
      recoverCountRemote: 0
    });

    if (this.state.calling) {
      
      this.sendMessage(this.state.calling, {action: 'stop', hide: hideStop}, 'call');

      if (this.state.calling && this.state.calling.pc) {
        this.state.calling.pc.close();
        delete this.state.calling.pc;
      }

      setTimeout(() => {
        this.stopStreams();
        this.clearCall();
        delete this.state.user.stream;

        if (!hideStop) {
          this.setState({
            callStatus: 'stopped'
          });
        }
        
        if (cb) {
          cb();
        }
      }, 16);
    }
    else {
      if (cb) {
        cb();
      }
    }
  }

  muteRemote() {
    let toggle = !this.state.muteRemote;

    if (this.state.calling && this.state.calling.stream) {
      this.state.calling.stream.getAudioTracks().forEach(s => s.enabled = !toggle);
    }

    this.setState({muteRemote: toggle});

    this.ulog(`Remote ${toggle ? 'muted' : 'unmuted'}`);
  }

  muteLocal() {
    let toggle = !this.state.muteLocal;
    
    if (this.state.user.stream) {
      this.state.user.stream.getAudioTracks().forEach(s => s.enabled = !toggle);
    }

    this.setState({muteLocal: toggle});

    this.ulog(`Local ${toggle ? 'muted' : 'unmuted'}`);
  }

  disableCam() {
    let toggle = !this.state.disableCam;

    if (this.state.user.stream) {
      this.state.user.stream.getVideoTracks().forEach(s => s.enabled = !toggle);
    }

    this.setState({disableCam: toggle});
    
    this.ulog(`Cam ${toggle ? 'disabled' : 'enabled'}`);
  }

  switchCam() {
    let newCD = this.state.activeCamDevice + 1;

    if (newCD >= this.state.videoDevices.length) {
      newCD = 0;
    }

    if (this.state.calling) {
      this.addEvent(this.state.calling, this.state.user, 'change');
    }

    this.setupLocalStream(null, newCD);
    
    this.ulog(`Cam switched`);
  }

  recoverStream(kind) {
    if (kind == 'local') {
      console.log("Not trying to recover local stream");
    }
    else if (kind == 'remote') {
      if (this.state.calling && this.state.calling.pc) {
        if (this.state.recoverCountLocal > 1) {
          console.log("Reconnect");
          this.reconnect();
        }
        else {
          this.sendMessage(this.state.calling, {'action': 'recover'}, 'call');
          this.setState({
            callStatus: 'recovering',
            recoverCountLocal: this.state.recoverCountLocal + 1
          });
        }
      }
    }
  }

  sendMessage(contact, data, type) {
    if (type === 'chat') {
      if (contact.datapc && contact.datachannel && contact.datachannel.readyState === 'open') {
        console.log("Sending chat message via datachannel");
        contact.datachannel.send(btoa(JSON.stringify(Object.assign({}, data, {type: type}))));
      }
      else {
        console.log("Data channel not open, could not deliver chat message");
      }
    }
    else {
      // send via server
      data.for = contact.id;
      data.type = type;
      this.socket.emit('pc', data);
      console.log("Sent msg via server", data);
    }
  }

  sendChatMessage(contact, msg) {
    if (contact && contact.datachannel) {
      let data = {
        from: this.state.user.id,
        text: msg,
        id: this.state.user.id + "-" + contact.id + "-" + parseInt(Math.random() * 100000),
        time: new Date()
      };

      const messages = (contact.messages || []).slice();
      messages.push(data);
      contact.messages = messages;
      
      this.sendMessage(contact, data, 'chat');

      this.setState({queue: this.state.queue});

      this.ulog(`Chat message sent to ${contact.id}`);
    }
  }

  issueCall(contact) {
    this.addEvent(contact, this.state.user, 'calling');
    this.setState({
      callStatus: 'calling',
      ringingUser: contact
    });
    this.sendMessage(contact, {action: 'calling'}, 'call');
  }

  issueStopCall() {
    if (this.state.calling) {
      this.addEvent(this.state.calling, this.state.user, 'callend');
      this.setState({
        calling: this.state.calling
      });
    }
    this.stopCall();
  }

  abortCall() {
    if (this.state.ringingUser) {
      this.sendMessage(this.state.ringingUser, {action: 'abort'}, 'call');
      this.addEvent(this.state.ringingUser, this.state.user, 'abort');
    }
    this.setState({
      callStatus: null
    });
  }

  streamsRunning() {
    this.setState({
      callStatus: 'established',
    });

    this.slog(`Streams running`);

    if (!this.state.contactOpen.streamsRunning) {
      this.state.contactOpen.streamsWereRunning = true;

      this.setState({
        contactOpen: this.state.contactOpen
      });

      this.checkCallMetadata(this.state.contactOpen);
    }
  }

  checkCallMetadata(contact) {
    if (contact.streamsWereRunning) {
      const requiredMetadata = Object.keys(this.props.callMetadata).filter(k => {
        const metadataEntry = this.props.callMetadata[k];

        return (metadataEntry.required && (!contact.metadata || !contact.metadata[k]));
      });

      if (requiredMetadata.length) {
        this.state.contactOpen.metadataInquiries = this.state.contactOpen.metadataInquiries || [];

        const metadataInquiryTime = this.state.contactOpen.metadataInquiries.length ?
          this.state.contactOpen.metadataInquiries[0].time :
          new Date();

        requiredMetadata.forEach(m => {
          let existing = this.state.contactOpen.metadataInquiries.find(c => c.metadataId === m);

          let conditions = this.props.callMetadata[m].showIf;
          if (conditions) {
            let isShown = Object.keys(conditions).every(key => {
              let currentValue = this.state.contactOpen.metadata[key];
              return currentValue === conditions[key];
            });

            if (!isShown) {
              this.state.contactOpen.metadataInquiries = this.state.contactOpen.metadataInquiries.filter(c => c.metadataId !== m);
              return;
            }
          }

          if (existing) {
            return;
          }
          else {
            this.state.contactOpen.metadataInquiries.push({
              type: 'inquiry',
              from: 'system',
              time: metadataInquiryTime,
              metadataId: m,
              metadata: this.props.callMetadata,
              values: this.state.contactOpen.metadata
            });
          }
        });

        this.setState({
          contactOpen: this.state.contactOpen
        });
      }
    }
  }

  showHelp() {
    if (this.state.calling) {
      this.setState({
        showInfo: this.context.intl.formatMessage(localeMessages.endCallForHelp)
      });
    }
    else {
      this.setState({
        contactOpen: null,
        showHelp: true
      });
    }
  }

  showProfile() {
    if (this.state.calling) {
      this.setState({
        showInfo: this.context.intl.formatMessage(localeMessages.endCallForLink)
      });
    }
    else {
      this.setState({
        contactOpen: null,
        showHelp: false
      });
    }
  }

  setLocale(lang) {
    if (window.localStorage) {
      window.localStorage.setItem('language', lang);
      window.localStorage.setItem('language_changed', true);
      window.location.reload();
    }
  }

  render() {
    const incomingCalls = Object.values(this.state.incomingCallQueue).map((contact) => {
      return <IncomingCall
        key={contact.id}
        accept={(contact) => this.acceptCall(contact)}
        deny={(contact) => this.denyCall(contact)}
        calling={this.state.calling}
        contact={contact} />
    });

    return (
      <MuiThemeProvider muiTheme={this.state.theme}>
        <div className={"flat outerShell" + (this.state.user ? ' loggedin': '')} style={{
          display:'flex',
          flexDirection: 'column',
          height: '100vh'}}>
          <div style={{zIndex: 10, display: 'flex', flexDirection: 'column', height: '100vh'}}>
            <AppBar
              className="appbar"
              style={{backgroundColor: '#009a3c', opacity: this.state.user ? 1 : 0}}
              iconElementLeft={<img className="logo" src={"Logo_" + this.props.locale + ".svg"} />}
              iconElementRight={
                this.state.user ?
                  <div>
                    <FlatButton
                      label={this.context.intl.formatMessage(localeMessages.showLinks)}
                      onClick={() => this.showProfile()}
                      style={{color:'white'}}/>
                    <FlatButton
                      label={this.context.intl.formatMessage(localeMessages.helpSupport)}
                      onClick={() => this.showHelp()}
                      style={{color:'white'}}/>
                    <IconMenu
                      iconButtonElement={
                        <FlatButton style={{color:'white'}} label={this.props.locale} />
                      }
                      targetOrigin={{horizontal: 'right', vertical: 'top'}}
                      anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    >
                      <MenuItem onClick={() => this.setLocale('de')} primaryText='Deutsch' className={this.props.locale === 'de' ? 'active' : ''} data-lang='de' />
                      <MenuItem onClick={() => this.setLocale('fr')} primaryText='Français' className={this.props.locale === 'fr' ? 'active' : ''} data-lang='fr' />
                      <MenuItem onClick={() => this.setLocale('it')} primaryText='Italiano' className={this.props.locale === 'it' ? 'active' : ''} data-lang='it' />
                    </IconMenu>
                    <AccountMenu
                      user={this.state.user}
                      onLogout={this.logout.bind(this)}
                    />
                  </div>
                  : <span></span>
              }
            />
            {this.state.user &&
              <div className={"app" + (this.state.calling || this.state.callStatus ? " calling" : '')}
                style={{
                  flex: 1,
                  display:'flex'
                }}
              >
                <Paper className="contentArea" style={{
                  display:'flex', flex: 1}}>
                  <div className="contactList" style={{borderRight: '1px solid #ccc'}}>
                    <div
                      className="contactheader"
                      onClick={() => {
                        this.setState({contactOpen: null, showHelp: false})
                      }}
                      style={{
                        backgroundColor: 'rgb(245, 245, 245)',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <div className="name">
                        <Avatar
                          icon={<AccountCircle />}
                          size={48}
                          style={{display:'inline-block', marginRight: '16px'}}
                        />
                        <div style={{display:'inline-block'}}>
                          <div style={{display:'inline-block'}}>{this.state.user.name}</div>
                          <div style={{marginTop:'0.2em'}}>
                            <span style={{color: (this.state.user.online ? greenA700 : 'red')}}>
                              {this.state.user.online ? 'Online' : 'Offline'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ContactList
                      disableEdits={true}
                      title={this.context.intl.formatMessage(localeMessages.connectedContacts)}
                      activeConversation={this.state.contactOpen}
                      user={this.state.user}
                      contacts={this.state.queue}
                      onContactClick={this.showContact.bind(this)} />
                    {!!this.state.staleQueue.length &&
                      <ContactList
                        disableEdits={true}
                        title={this.context.intl.formatMessage(localeMessages.passedConversations)}
                        user={this.state.user}
                        activeConversation={this.state.contactOpen}
                        contacts={this.state.staleQueue}
                        onContactClick={this.showContact.bind(this)} />
                    }
                  </div>
                  <div style={{
                      flex: 3,
                      backgroundColor: grey100,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'auto'
                    }}>
                    {!this.state.contactOpen && !this.state.showHelp &&
                      <SupporterProfile
                        locale={this.props.locale}
                        user={this.state.user}
                        clientprefix={this.state.clientprefix}
                        mailfooter={this.state.mailfooter}
                        mailsender={this.state.mailsender}
                        labels={this.state.labels}
                        sendMail={this.sendMail}
                        mailTheme={this.state.theme}
                      />
                    }
                    {!this.state.contactOpen && this.state.showHelp &&
                      <Help />
                    }
                    {this.state.contactOpen &&
                      <ContactWindow
                        user={this.state.user}
                        calling={this.state.calling}
                        messages={this.state.contactOpen.messages || []}
                        metadataInquiries={this.state.contactOpen.metadataInquiries || []}
                        events={this.state.contactOpen.events || []}
                        onMessage={(to, msg) => this.sendChatMessage(to, msg)}
                        contact={this.state.contactOpen}
                        onError={(kind) => this.recoverStream(kind)}
                        onCall={() => this.issueCall(this.state.contactOpen)}
                        onMessagesUpdate={(messages) => {
                          this.state.contactOpen.messages = messages;
          
                          this.setState({
                            contactOpen: this.state.contactOpen
                          });
                        }}

                        onStreamsRunning={() => this.streamsRunning()}
                        callStatus={this.state.callStatus}
                        onMuteRemote={() => this.muteRemote()}
                        onMuteLocal={() => this.muteLocal()}
                        onStopCall={() => this.issueStopCall()}
                        onDisableCam={() => this.disableCam()}
                        onSwitchCam={() => this.switchCam()}
                        clearCallStatus={() => this.clearCallStatus()}
                        onAbortCall={() => this.abortCall()}
                        muteRemote={this.state.muteRemote}
                        muteLocal={this.state.muteLocal}
                        disableCam={this.state.disableCam}
                        audioDevices={this.state.audioDevices}
                        videoDevices={this.state.videoDevices}
                        
                        locale={this.props.locale}
                        callMetadata={this.props.callMetadata}
                        callMetadataValues={this.state.contactOpen.metadata}
                        onChangeCallMetadata={(k, v) => {
                          this.state.contactOpen.metadata[k] = v;

                          const values = {};
                          Object.keys(this.state.contactOpen.metadata).forEach(k => {
                            values[k] = {
                              type: this.props.callMetadata[k].type,
                              title: this.props.callMetadata[k].title['de']
                            };

                            switch (values[k].type) {
                              case 'multiple':
                                values[k]['values'] = this.state.contactOpen.metadata[k].map(ix => this.context.intl.formatMessage({
                                  id: "metadata." + k + ".values." + ix
                                })).join(', ');
                                break;
                              case 'list':
                                values[k]['values'] = this.context.intl.formatMessage({
                                  id: "metadata." + k + ".values." + this.state.contactOpen.metadata[k]
                                });
                                break;
                              default:
                                values[k]['values'] = this.state.contactOpen.metadata[k];
                            }
                          });
                          this.socket.emit('metadata', [this.state.contactOpen.id, values]);

                          this.setState({
                            contactOpen: this.state.contactOpen
                          }, () => this.checkCallMetadata(this.state.contactOpen));
                        }}
                        />}
                  </div>
                  <div className="incomingCalls">
                    {incomingCalls}
                  </div>
                </Paper>
              </div>}
            </div>
          {!this.state.user && 
            <LoginDialog
              locale={this.props.locale}
              labels={this.state.labels}
              authfail={this.state.authfail}
              loggedout={this.state.loggedout}
              onLogin={(username, password) => this.requestAuthentication(username, password)} />
          }
          {!this.state.user && <LanguageSwitcher setLocale={this.setLocale} locale={this.props.locale} />}
          {this.state.confirmContactDeletion &&
            <ConfirmContactDeleteDialog
              contact={this.state.confirmContactDeletion}
              onClose={() => this.setState({confirmContactDeletion:null})}
              onDelete={() => {
                this.deleteContact(this.state.confirmContactDeletion);
                this.setState({confirmContactDeletion:null});
              }}
            />}
          {this.state.editContact &&
            <ContactEditor
              contact={JSON.parse(JSON.stringify(this.state.editContact))}
              onClose={() => this.setState({editContact:null})}
              onSave={(c) => {
                this.saveContact(c);
                this.setState({editContact:null});
              }}
            />}
          <Snackbar
            open={!!this.state.showInfo}
            message={this.state.showInfo}
            autoHideDuration={4000}
            onRequestClose={this.hideInfo}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js